import axios from 'axios';

export const state = {};

export const getters = {};

export const mutations = {};

export const actions = {
    async index(
        vuexContext,
        {
            currentPage = 1,
            perPage = 10,
            search = null,
            sortBy = null,
            descending = true,
            filters,
            attributes
        }
    ) {
        const { data } = await axios.get(`/feedback`, {
            params: {
                page: currentPage,
                perPage,
                q: search,
                sortBy,
                order: descending ? 'DESC' : 'ASC',
                filters: JSON.stringify(filters),
                attributes
            }
        });

        return data;
    }
};
